import { render, staticRenderFns } from "./IndexData.vue?vue&type=template&id=ee8d6364&scoped=true&"
import script from "./IndexData.vue?vue&type=script&lang=js&"
export * from "./IndexData.vue?vue&type=script&lang=js&"
import style0 from "./IndexData.vue?vue&type=style&index=0&id=ee8d6364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8d6364",
  null
  
)

export default component.exports